import { Pays } from './pays.model';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
export class Operateur {
    static jsonMap = {
        id: { key: 'id', optional: true },
        email: { key: 'email', optional: true, default: '' },
        nom: { key: 'nom', optional: true, default: '' },
        prenom: { key: 'prenom', optional: true, default: '' },
        raisonSociale: { key: 'raisonSociale', optional: true, default: '' },
        siret: { key: 'siret', optional: true, default: '' },
        structureJuridique: { key: 'structureJuridique', optional: true, default: '' },
        adresse: { key: 'adresse', optional: true, default: '' },
        codePostal: { key: 'codePostal', optional: true, default: '' },
        ville: { key: 'ville', optional: true, default: '' },
        idPays: { key: 'idPays', optional: true },
        idEntreprise: { key: 'idEntreprise', optional: true },
        pays: { key: 'pays', converter: new (DataIdConverterFactory.build(Pays, 'pays'))(), optional: true },
        cedex: { key: 'cedex', optional: true, default: '' },
        tvaIntracommunautaire: { key: 'tvaIntracommunautaire', optional: true, default: '' },
        telephoneFixe: { key: 'telephoneFixe', optional: true, default: '' },
        telephoneMobile: { key: 'telephoneMobile', optional: true, default: '' },
        fax: { key: 'fax', optional: true, default: '' },
        numeroCVI: { key: 'numeroCVI', optional: true, default: '' }
    };

    public id: number;
    email: string;
    nom: string;
    prenom: string;
    raisonSociale: string;
    siret: string;
    structureJuridique: string;
    adresse: string;
    codePostal: string;
    ville: string;
    idPays: number;
    idEntreprise: number;
    pays: Pays;
    cedex: string;
    tvaIntracommunautaire: string;
    telephoneFixe: string;
    telephoneMobile: string;
    fax: string;
    numeroCVI: string;

    public getCustomLabel(): string {
        return `${this.prenom} ${this.nom} ${this.raisonSociale ? `(${this.raisonSociale})` : ''}`;
    }

    public toString(): string {
        // return `${this.prenom} ${this.nom}`;
        return this.raisonSociale;
    }
}
